import { FormatTypes } from '../../../../../../constants/templateDictionaries';

export default (params) => {
  const {
    type,
    sectionIndex,
    userResumePreferences,
    setUserPreferences,
    exportStatus,
    updateType,
  } = params;

  let { requiredUserPref } = params;

  if (updateType === 'section') {
    requiredUserPref = {
      ...requiredUserPref,
      toExport: exportStatus,
    };
  } else {
    requiredUserPref = {
      ...requiredUserPref,
      toExport: {
        ...requiredUserPref.toExport,
        [type]: exportStatus,
      },
    };
  }

  const updatedUserPreferences = {
    ...userResumePreferences,
    leftPane: {
      ...userResumePreferences.leftPane,
      used: [
        ...userResumePreferences.leftPane.used.slice(0, sectionIndex),
        requiredUserPref,
        ...userResumePreferences.leftPane.used.slice(sectionIndex + 1),
      ],
    },
  };

  setUserPreferences({
    userPreferences: updatedUserPreferences,
    formatType: FormatTypes.RESUME, // Get the format type from redux if this is going to be reusable
  });
};
